function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_115",
  "data-name": "Group 115",
  transform: "translate(-976 -200)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_7",
  "data-name": "Ellipse 7",
  transform: "translate(976 200)",
  fill: "#fff",
  stroke: "#6236ff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 23.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_113",
  "data-name": "Group 113",
  transform: "translate(17040 -2628)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Document_3024619",
  transform: "translate(-16050 2839)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_112",
  "data-name": "Group 112",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_310",
  "data-name": "Path 310",
  d: "M192.043,112.005H174.651A1.654,1.654,0,0,1,173,110.354v-22.7A1.654,1.654,0,0,1,174.651,86h12.243l6.8,6.8v17.553A1.654,1.654,0,0,1,192.043,112.005ZM174.651,86.916a.736.736,0,0,0-.736.736v22.7a.736.736,0,0,0,.736.736h17.392a.736.736,0,0,0,.736-.736V93.179l-6.263-6.263Z",
  transform: "translate(-173 -86)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_38",
  "data-name": "Rectangle 38",
  width: 10,
  height: 1,
  transform: "translate(5 12)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_39",
  "data-name": "Rectangle 39",
  width: 10,
  height: 1,
  transform: "translate(5 16)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_40",
  "data-name": "Rectangle 40",
  width: 6,
  height: 1,
  transform: "translate(5 20)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_311",
  "data-name": "Path 311",
  d: "M613.99,107.99h-5.427A1.566,1.566,0,0,1,607,106.427V101h.916v5.427a.647.647,0,0,0,.647.647h5.427Z",
  transform: "translate(-593.753 -100.542)"
})))));

var SvgCircleNotification = function SvgCircleNotification(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircleNotification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CircleNotification.0ed95b59.svg";
export { ForwardRef as ReactComponent };